export enum FilterStatus {
  disable = 'disabled',
  loading = 'loading',
  active = 'active'
}